import type { Account } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAccount } from "./useAccount"

export function useAccountProperty<
  K extends keyof Account,
  V,
>(
  property: K,
  defaultValue?: V,
): V

export function useAccountProperty<
  K extends keyof Account,
>(
  property: K,
  defaultValue: Account[K],
): Account[K]

export function useAccountProperty<
  K extends keyof Account,
>(
  property: K,
  defaultValue?: Account[K],
) {
  const { data: account } = useAccount()

  return useMemo(
    () => account?.[property] ?? defaultValue ?? undefined,
    [
      account,
      property,
      defaultValue,
    ],
  )
}
